export enum LocalStorageKeys {
  authRedirect = 'authRedirect',
  userLang = 'userLang'
}
